<template>
  <v-list>
    <v-subheader>
      Recently Viewed
    </v-subheader>
    <v-list-item
      v-for="pharm in recentPeople"
      :key="pharm.id"
      :to="'/people/' + pharm.id"
    >
      <v-list-item-content>
        <div>
          {{ pharm.id }} -
          <span v-if="pharm.nickname">
            {{ pharm.nickname }} {{ pharm.surname }}
          </span>
          <span v-else> {{ pharm.firstname }} {{ pharm.surname }} </span>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "recentlyViewedPeople",
  computed: {
    recentPeople() {
      return this.$store.state.ui.recentPeople.filter(p => p.id);
    }
  }
};
</script>
